import { useSelector } from "react-redux";
import { MessageSquarePlus, List, MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";

const BotHeader = ({
  headerTitle,
  isChatBotVisible,
  toggleView,
  accessToken,
  botType,
}) => {
  const { t } = useTranslation(["user"]);

  const userType = useSelector((state) => state?.userInfo?.userType);

  /* ================================================================
   *  Icon Button (شیشه‌ای/طلایی)
   * ================================================================ */
  const IconActionButton = ({ icon: Icon, label, onClick, tone = "gold" }) => {
    const toneClass =
      tone === "gold"
        ? "from-amber-300 to-amber-500 text-slate-900 shadow-[0_6px_20px_-6px_rgba(251,191,36,0.8)] hover:from-amber-200 hover:to-amber-400"
        : "from-teal-500 to-teal-700 text-white shadow-[0_6px_20px_-6px_rgba(20,184,166,0.8)] hover:from-teal-400 hover:to-teal-600";

    return (
      <div className="relative group shrink-0">
        <button
          type="button"
          onClick={onClick}
          aria-label={label}
          className={`
            group/btn relative
            flex items-center justify-center gap-2
            h-10 px-3 sm:px-4 rounded-xl
            text-[12px] sm:text-[13px] font-bold
            bg-gradient-to-l ${toneClass}
            border border-white/20
            backdrop-blur-md
            transition-all duration-300
            hover:scale-105 active:scale-95
            whitespace-nowrap
          `}
        >
          <Icon size={17} className="shrink-0" />
          <span className="hidden sm:inline">{label}</span>

          {/* درخشش داخلی */}
          <span className="pointer-events-none absolute inset-0 rounded-xl bg-gradient-to-br from-white/0 via-white/10 to-white/0 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-500" />
        </button>

        {/* Tooltip در موبایل */}
        <span
          className="
            sm:hidden pointer-events-none absolute top-full mt-2 left-1/2 -translate-x-1/2
            whitespace-nowrap rounded-md
            bg-slate-900/95 text-white text-[10px] font-medium
            py-1 px-2 border border-amber-300/30
            opacity-0 group-hover:opacity-100
            -translate-y-1 group-hover:translate-y-0
            transition-all duration-200
            shadow-lg z-50
          "
        >
          {label}
        </span>
      </div>
    );
  };

  return (
    <div
      id="bot-header"
      className="
        relative grid grid-cols-1 mb-4 sm:mb-5 shrink-0
        pb-3
        border-b border-teal-500/15 dark:!border-teal-400/15
      "
    >
      <div className="flex items-center justify-between gap-3">

        {/* ---------- Title ---------- */}
        <div className="flex items-center gap-2.5 min-w-0">
          <span
            className="
              shrink-0 flex h-9 w-9 items-center justify-center rounded-xl
              bg-gradient-to-br from-amber-300/30 to-teal-400/20
              border border-amber-300/40
              text-amber-400
            "
          >
            <MessageSquare size={17} />
          </span>
          <div className="min-w-0">
            <h4 className="text-sm sm:text-base font-bold text-slate-800 dark:!text-amber-100 truncate">
              {headerTitle}
            </h4>
            <p className="text-[10px] sm:text-[11px] text-slate-500 dark:!text-slate-400 truncate">
              {isChatBotVisible
                ? t("botHeader.conversationList")
                : t("botHeader.selectedConversation")}
            </p>
          </div>
        </div>

        {/* ---------- Actions ---------- */}
        <div className="flex items-center gap-2 shrink-0">

          {/* کاربر نوع 1 + supportBot */}
          {userType == 1 && botType === "supportBot" && (
            isChatBotVisible ? (
              <IconActionButton
                icon={MessageSquarePlus}
                label={t("botHeader.newChat")}
                onClick={toggleView}
                tone="gold"
              />
            ) : (
              <IconActionButton
                icon={List}
                label={t("botHeader.conversationsList")}
                onClick={toggleView}
                tone="teal"
              />
            )
          )}

          {/* کاربر نوع 2 + supportBot (فقط دکمه لیست) */}
          {userType == 2 && botType === "supportBot" && !isChatBotVisible && (
            <IconActionButton
              icon={List}
              label={t("botHeader.conversationsList")}
              onClick={toggleView}
              tone="teal"
            />
          )}

          {/* RayaBot (اگه لازم بود در آینده) */}
          {userType == 1 && botType === "RayaBot" && !isChatBotVisible && (
            <IconActionButton
              icon={List}
              label={t("botHeader.conversationsList")}
              onClick={toggleView}
              tone="teal"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BotHeader;